import { useState } from "react";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Textarea } from "../../ui/textarea";
import { Mail, User, MessageSquare, Send, Loader2 } from "lucide-react";

export function ContactForm() {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulación de envío de formulario
    setTimeout(() => {
      /* toast({
        title: "Mensaje enviado",
        description: "Nos pondremos en contacto contigo pronto.",
      }) */
      alert("Mensaje enviado. Nos pondremos en contacto contigo pronto.");
      setIsLoading(false);
      setFormData({ name: "", email: "", message: "" });
    }, 1500);
  };

  return (
    <section id="contacto" className="py-20 bg-gradient-to-b from-[#fefcf9] to-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="block text-sm uppercase text-[#6E4B28]/70 font-semibold tracking-wider mb-3">
            Estamos para atenderte
          </span>
          <h2 className="text-4xl font-extrabold text-[#6E4B28]">
            Contáctanos
          </h2>
          <div className="w-20 h-1 bg-[#6E4B28] mx-auto mt-4 rounded-full"></div>
          <p className="mt-4 text-gray-600 max-w-lg mx-auto">
            ¿Tienes alguna pregunta sobre nuestra institución? Estamos aquí para ayudarte.
          </p>
        </div>
        
        <div className="bg-white shadow-xl rounded-2xl overflow-hidden">
          <div className="grid md:grid-cols-5">
            <div className="md:col-span-2 bg-[#6E4B28] p-8 text-white">
              <h3 className="text-xl font-bold mb-4">Información de contacto</h3>
              <p className="mb-8 text-white/80">Completa el formulario y te responderemos a la brevedad.</p>
              
              <div className="space-y-6 mt-10">
                <a
                  href="mailto:informes@iepsanisidro.edu.pe"
                  className="flex items-center gap-3 text-white no-underline hover:no-underline hover:text-white"
                >
                  <Mail className="h-5 w-5" />
                  <span>informes@iepsanisidro.edu.pe</span>
                </a>
                <a
                  href="tel:+51941699392"
                  className="flex items-center gap-3 text-white no-underline hover:no-underline hover:text-white"
                >
                  <MessageSquare className="h-5 w-5" />
                  <span>+51 941 699 392</span>
                </a>
              </div>
            </div>
            
            <div className="md:col-span-3 p-8">
              <form className="space-y-6" onSubmit={handleSubmit}>
                <div className="space-y-4">
                  <label htmlFor="name" className="text-sm font-semibold text-[#6E4B28] flex items-center gap-2">
                    <User className="h-4 w-4" />
                    Nombre completo
                  </label>
                  <div className="relative">
                    <Input
                      id="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Tu nombre"
                      className="border-[#6E4B28]/20 focus-visible:ring-[#6E4B28] pl-10 py-2"
                      required
                    />
                    <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                  </div>
                </div>
                
                <div className="space-y-4">
                  <label htmlFor="email" className="text-sm font-semibold text-[#6E4B28] flex items-center gap-2">
                    <Mail className="h-4 w-4" />
                    Correo electrónico
                  </label>
                  <div className="relative">
                    <Input
                      id="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="tu@email.com"
                      className="border-[#6E4B28]/20 focus-visible:ring-[#6E4B28] pl-10 py-2"
                      required
                    />
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                  </div>
                </div>
                
                <div className="space-y-4">
                  <label htmlFor="message" className="text-sm font-semibold text-[#6E4B28] flex items-center gap-2">
                    <MessageSquare className="h-4 w-4" />
                    Mensaje
                  </label>
                  <div className="relative">
                    <Textarea
                      id="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="¿En qué podemos ayudarte?"
                      className="min-h-[150px] border-[#6E4B28]/20 focus-visible:ring-[#6E4B28] pl-10 pt-4"
                      required
                    />
                    <MessageSquare className="absolute left-3 top-5 h-4 w-4 text-gray-400" />
                  </div>
                </div>
                
                <Button 
                  type="submit" 
                  disabled={isLoading}
                  className="w-full web-btn-secondary"
                >
                  {isLoading ? (
                    <>
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                      Enviando...
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      Enviar mensaje
                    </>
                  )}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
